import { render, staticRenderFns } from "./FormDate.vue?vue&type=template&id=bbf7eb7c&functional=true"
import script from "./FormDate.vue?vue&type=script&lang=js"
export * from "./FormDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf7eb7c')) {
      api.createRecord('bbf7eb7c', component.options)
    } else {
      api.rerender('bbf7eb7c', component.options)
    }
    module.hot.accept("./FormDate.vue?vue&type=template&id=bbf7eb7c&functional=true", function () {
      api.rerender('bbf7eb7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/FormDate.vue"
export default component.exports